var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductDetail',{attrs:{"product":_vm.product,"fetching":_vm.fetching,"error":_vm.error,"nodata":_vm.nodata}})
}
var staticRenderFns = []

export { render, staticRenderFns }